<!-- We can't use <label for="inputId()"> because we don't have a native control to link to.
  We should consider using the native select <select matNativeControl> for proper accessibility -->
<!-- (click) event on span just mimics behavior of <label>--this does not need to be keyboard accessible -->
<span
  [id]="labelId()"
  [innerHTML]="labelAsHtml"
  class="emperor-ui-form-field-label"
  (click)="select.focus()"
></span>
<mat-form-field
  appearance="outline"
  class="emperor-ui-full-width emperor-ui-select-input"
>
<!-- Because the label isn't already associated with the control, we need to add the label to the aria-labelledby -->
  <mat-select
    [formControl]="control"
    [aria-labelledby]="labelId() + ' ' + ariaLabelledBy"
    [id]="inputId()"
    [attr.data-test]="qaAttributeHook"
    (blur)="onBlur()"
    (focus)="onFocus()"
    disableOptionCentering
    [multiple]="multi"
    #select
    [placeholder]="placeholder ?? ''"
  >
    <mat-select-trigger *ngIf="selectTrigger">{{
      selectTrigger
    }}</mat-select-trigger>
    <mat-option *ngFor="let choice of choices" [value]="choice.value">
      <emperor-icon *ngIf="!!choice.icon" [name]="choice.icon"></emperor-icon>
      <span [ngClass]="{ 'emperor-ui-select-label': !!choice.icon }">
        {{ choice.label }}
      </span>
    </mat-option>
  </mat-select>
  <mat-error
    emperorErrorHandler
    [errorText]="errorText"
    [errorMessageMap]="errorMessageMap"
    [id]="code || ''"
  ></mat-error>
  <mat-hint *ngIf="!!hint && !hintWithIcon" [innerHtml]="hint"></mat-hint>
  <mat-hint *ngIf="!!hintWithIcon">
    <emperor-hint-with-icon
      [hintWithIcon]="hintWithIcon"
    ></emperor-hint-with-icon>
  </mat-hint>
</mat-form-field>
